import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardBody, Input } from 'reactstrap';

const MAX_CONTRACT_YEARS = 5;
const DEFAULT_CONTRACT_TERM = 36;
const SPECIFY = 'custom';

const buildDropdownOptions = (isMTM) => [
  ...(isMTM ? [0] : []),
  ...Array.from({ length: MAX_CONTRACT_YEARS }, (_, i) => (i + 1) * 12),
];

const QuoteSettingsPanel = ({ title, quoteTypes, quoteTypeValue, contractMonths, onQuoteTypeChange, onContractMonthsChange, otherQuoteTypeValue }) => {
  const isMTM = parseInt(quoteTypeValue) === 1;
  const dropdownOptions = buildDropdownOptions(isMTM);
  const inDropdown = (val) => dropdownOptions.includes(parseInt(val));

  const [specifyMode, setSpecifyMode] = useState(
    contractMonths != null && !inDropdown(contractMonths)
  );
  const [customValue, setCustomValue] = useState(
    contractMonths != null && !inDropdown(contractMonths) ? String(contractMonths) : ''
  );

  const defaultApplied = useRef(false);
  useEffect(() => {
    if (contractMonths != null) {
      defaultApplied.current = true;
      return;
    }
    if (!defaultApplied.current && quoteTypeValue != null && quoteTypeValue !== '') {
      defaultApplied.current = true;
      onContractMonthsChange(isMTM ? 0 : DEFAULT_CONTRACT_TERM);
    }
  });

  useEffect(() => {
    if (contractMonths == null) return;
    const opts = buildDropdownOptions(parseInt(quoteTypeValue) === 1);
    if (opts.includes(parseInt(contractMonths))) {
      setSpecifyMode(false);
    } else {
      setSpecifyMode(true);
      setCustomValue(String(contractMonths));
    }
  }, [contractMonths, quoteTypeValue]);

  const handleQuoteTypeChange = (value) => {
    onQuoteTypeChange(value);
    if (value === '') return;
    if (parseInt(value) === 1) {
      onContractMonthsChange(0);
    } else if (parseInt(contractMonths) === 0 || contractMonths == null) {
      onContractMonthsChange(DEFAULT_CONTRACT_TERM);
    }
  };

  const handleDropdownChange = (e) => {
    const val = e.target.value;
    if (val === SPECIFY) {
      setSpecifyMode(true);
      setCustomValue('');
      onContractMonthsChange(null);
    } else {
      setSpecifyMode(false);
      onContractMonthsChange(val);
    }
  };

  const handleCustomChange = (e) => {
    const val = e.target.value;
    setCustomValue(val);
    if (val !== '') onContractMonthsChange(val);
  };

  const selectValue = specifyMode ? SPECIFY : (contractMonths != null ? contractMonths : dropdownOptions[0] ?? '');

  return (
    <Row>
      <Col lg="12">
        <Card>
          <CardBody>
            <h4 className="mt-0 header-title">{title}</h4>
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr>
                    <th scope="row">Quote type <span className="text-danger">*</span></th>
                    <td>
                      {quoteTypes && quoteTypeValue !== null && (
                        <select
                          className="form-control"
                          value={quoteTypeValue}
                          onChange={(e) => handleQuoteTypeChange(e.target.value)}
                        >
                          <option value="" disabled={otherQuoteTypeValue === ''}>None</option>
                          {quoteTypes.map((qt, i) =>
                            (qt.Active === 1 || parseInt(qt.QuoteTypeId) === parseInt(quoteTypeValue)) && (
                              <option key={i} value={qt.QuoteTypeId}>{qt.Name}</option>
                            )
                          )}
                        </select>
                      )}
                    </td>
                  </tr>
                  {!!quoteTypeValue && (contractMonths != null || specifyMode) && (
                    <tr>
                      <th scope="row">Contract period <span className="text-danger">*</span></th>
                      <td>
                        <select
                          className="form-control"
                          value={selectValue}
                          onChange={handleDropdownChange}
                        >
                          {dropdownOptions.map(m => (
                            <option key={m} value={m}>{m} months</option>
                          ))}
                          <option value={SPECIFY}>Other...</option>
                        </select>
                        {specifyMode && (
                          <Input
                            type="number"
                            min="1"
                            className="mt-2"
                            value={customValue}
                            onChange={handleCustomChange}
                            placeholder="Months"
                          />
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default QuoteSettingsPanel;
